import AdministrativePaymentInvoicingPage from "./AdministrativePaymentInvoicingPage";

export default function AdministrativePaymentRoute() {
  return <AdministrativePaymentInvoicingPage />;
}
